export default __webpack_public_path__ + "static/media/malmo.7091b342.webp";